import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR, UntypedFormGroup,} from '@angular/forms';
import {FieldConfig, FieldType} from '../field.interface';
import * as L from "leaflet";

@Component({
  selector: 'app-input-map',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputMapComponent),
      multi: true,
    },
  ],
  template: `
    <!--    <ng-container *ngIf="field">-->
    <!--      <div *ngIf="field.inputType != 'hidden'">-->
    <div>{{ field.label }}</div>
    <div class="h-48 w-full rounded-xl overflow-hidden border border-[#9E9E9E] mt-2">
      <div class="h-full w-full" id="map"></div>
    </div>
    <!--      <mat-form-field-->
    <!--        class="demo-full-width"-->
    <!--        [formGroup]="group"-->
    <!--        hidden-->
    <!--        appearance="outline"-->
    <!--      >-->
    <!--      </mat-form-field>-->
  `,
  // host: {'class': 'col-md-6'},
  styles: ['.danger { color:red }'],
})
export class InputMapComponent implements OnInit, ControlValueAccessor, OnChanges {
  @Input() field!: FieldConfig;
  @Input() group: UntypedFormGroup = new UntypedFormGroup({});
  @Output() fieldValue = new EventEmitter();
  value: any;
  disabled = false;

  // @HostBinding('class') rowClass = 'col-md-6';
  constructor() {
  }

  onChange: any = () => {
  };

  onTouched: any = () => {
  };

  settingValue($event: any): void {
    this.value = $event;
    // if(this.field.key){
    //   this.group.controls[this.field.key].setValue(this.value)
    // }
    this.onChange(this.value);
  }

  writeValue(value: any): void {
    console.log('vvvv')
    if (value !== undefined) {
      this.fieldChange(value);
    }
  }


  registerOnChange(onChange: any): void {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  ngOnInit() {
    const {
      lng,
      lat
    } = this.group.get(this.field?.key).value ? JSON.parse(this.group.get(this.field?.key).value) : {
      lat: null,
      lng: null
    }
    let that = this;
    var map = L.map('map').setView([lat ?? -6.161184, lng ?? 35.745426], 10);

    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
    }).addTo(map);

    map.locate({setView: false, maxZoom: 16});

    // Event listeners for location found and error
    if (!lat || !lng) {
      map.on('locationfound', (e) => {
        map.setView(e.latlng, 20);

        // Add a marker at the current location
        const marker = L.marker(e.latlng, {draggable: true}).addTo(map)
          .bindPopup("Drag Location").openPopup();

        marker.on('dragend', function (e) {
          var position = [e.target._latlng.lat, e.target._latlng.lng];
          marker.setLatLng(position, {draggable: 'true'}).bindPopup('Drag Location').openPopup();
          map.panTo(position);
          that.setFormData(e)
          // that.selectedLocation.emit({ lat: e.target._latlng.lat, lng: e.target._latlng.lng })
        });

      });
      map.on('locationerror', (e) => {
        map.setView([-6.161184, 35.745426], 10);

        // Add a marker at the current location
        const marker = L.marker([-6.161184, 35.745426], {draggable: true}).addTo(map)
          .bindPopup("Drag Location").openPopup();

        marker.on('dragend', function (e) {
          var position = [e.target._latlng.lat, e.target._latlng.lng];
          marker.setLatLng(position, {draggable: 'true'}).bindPopup('Drag Location').openPopup();
          map.panTo(position);
          that.setFormData(e)
          // that.selectedLocation.emit({ lat: e.target._latlng.lat, lng: e.target._latlng.lng })
        });
      });
    } else {

      console.log('1234')
      const marker = L.marker([lat, lng], {draggable: true}).addTo(map)
        .bindPopup("Drag Location").openPopup();
      map.setView([lat, lng], 20);
      map.panTo([lat, lng]);

      marker.on('dragend', function (e) {
        var position = [e.target._latlng.lat, e.target._latlng.lng];
        marker.setLatLng(position, {draggable: 'true'}).bindPopup('Drag Location').openPopup();
        map.panTo(position);
        that.setFormData(e)
        // that.selectedLocation.emit({ lat: e.target._latlng.lat, lng: e.target._latlng.lng })
      });
    }


    // this.group.addControl(
    //   this.field?.key || 'id',
    //   new UntypedFormControl('', [])
    // );
    //  this.rowClass = this.field.rowClass === 'large' ? 'col-md-12' : 'col-md-6';
  }

  ngOnChanges() {

    if (this.field?.disabled) {
      this.group.controls[this.field.key as string].disable();
    }
  }

  setFormData(e: any) {
    this.group.get(this.field.key).setValue({lat: e.target._latlng.lat, lng: e.target._latlng.lng});
    this.fieldValue.emit({
      value: {lat: e.target._latlng.lat, lng: e.target._latlng.lng},
      field: this.field,
      object: {}
    });

  }

  fieldChange(v: any = null) {
    let value = v?.target?.value;
    // if (this.field.inputType == 'number') {
    //   value = parseFloat(value.replace(/,/g, ''));
    // }
    // if (this.field.key) this.group.controls[this.field.key].setValue(value);
    let formatedValue = value;
    if (this.field.type == FieldType.input && this.field.inputType == 'number') {
      formatedValue = parseFloat(value?.replace(/,/g, ''));
    }
    console.log('value from Yeeh!!', v)
    this.fieldValue.emit({value: formatedValue, field: this.field, object: {}});
  }
}
